<template>
    <div>
        <v-navigation-drawer v-model="drawer" app clipped>
            <v-list dense>
                <v-subheader class="mt-4 grey--text text--darken-1">{{ $t('nav-lbl-store') }}</v-subheader>
                <v-list>
                    <v-list-item link @click="changeStore('ko-kr')">
                        <v-list-item-action>
                            <v-icon v-if="conditions.locale === 'ko-kr'">mdi-check-circle</v-icon>
                            <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title><flag iso="kr" /><span style="margin-left: 5px;">{{ $t('nav-lbl-kr-store') }}</span></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link @click="changeStore('en-us')">
                        <v-list-item-action>
                            <v-icon v-if="conditions.locale === 'en-us'">mdi-check-circle</v-icon>
                            <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title><flag iso="us" /><span style="margin-left: 5px;">{{ $t('nav-lbl-us-store') }}</span></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-subheader class="mt-4 grey--text text--darken-1">{{ $t('nav-lbl-theme') }}</v-subheader>
                <v-list-item link @click="toggleTheme">
                    <v-list-item-action>
                        <v-icon v-if="isDark">mdi-checkbox-marked</v-icon>
                        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('nav-lbl-theme-dark') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-subheader class="mt-4 grey--text text--darken-1">{{ $t('nav-lbl-games') }}</v-subheader>
                <v-list-item link @click="toggleDiscount">
                    <v-list-item-action>
                        <v-icon v-if="isDiscountOnly">mdi-checkbox-marked</v-icon>
                        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('nav-lbl-discount-only') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="toggleGamePass">
                    <v-list-item-action>
                        <v-icon v-if="isGamePass">mdi-checkbox-marked</v-icon>
                        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>GamePass</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="toggleEaPlay">
                    <v-list-item-action>
                        <v-icon v-if="isEaPlay">mdi-checkbox-marked</v-icon>
                        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>EA Play</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-subheader class="mt-4 grey--text text--darken-1">{{ $t('nav-lbl-order-priority') }}</v-subheader>
                <v-list>
                    <v-list-item link @click="changePriority('NONE')">
                        <v-list-item-action>
                            <v-icon v-if="conditions.sortPriority === 'NONE'">mdi-check-circle</v-icon>
                            <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ $t('nav-lbl-order-priority-none') }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link @click="changePriority('PRICE')">
                        <v-list-item-action>
                            <v-icon v-if="conditions.sortPriority === 'PRICE'">mdi-check-circle</v-icon>
                            <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ $t('nav-lbl-order-priority-price') }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link @click="changePriority('PERCENT')">
                        <v-list-item-action>
                            <v-icon v-if="conditions.sortPriority === 'PERCENT'">mdi-check-circle</v-icon>
                            <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ $t('nav-lbl-order-priority-percent') }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                
                <v-subheader class="mt-4 grey--text text--darken-1">{{ $t('nav-lbl-optional') }}</v-subheader>
                <v-list-item link @click="toggleScreen">
                    <v-list-item-action>
                        <v-icon v-if="isScreenshot">mdi-checkbox-marked</v-icon>
                        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('nav-lbl-optional-screenshop') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <!--
                <v-list-item link @click="toggleHistory">
                    <v-list-item-action>
                        <v-icon v-if="isHistory">mdi-checkbox-marked</v-icon>
                        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>HISTORY</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                -->
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app clipped-left color="light-green darken-4" dense>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <v-toolbar-title class="mr-12 align-center" style="padding-left:0px !important;">
                <span class="title font-weight-bold">XBOX SHOPPER</span>
                <flag iso="kr" v-if="conditions.locale === 'ko-kr'" style="border-radius: 10px; margin-left: 5px;" />
                <flag iso="us" v-else style="border-radius: 10px; margin-left: 5px;" />
            </v-toolbar-title>
            <v-spacer />

            <v-progress-circular v-if="isLoading" indeterminate />
            <v-icon v-else class="mx-4" style="margin-right: 0px !important;" @click="openBottomSearcher">{{ magnify }}</v-icon>
        </v-app-bar>
    </div>
</template>

<script>
export default {
    props: [ 'conditions', 'isFiltering' ],
    data: () => ({
        drawer: null,
        isDark: true,
        isDiscountOnly: true,
        isGamePass: false,
        isEaPlay: false,
        isScreenshot: true,
        isHistory: true,
        isLoading: false
    }),
    computed: {
        magnify () {
            return this.isFiltering ? 'mdi-magnify-scan' : 'mdi-magnify'
        }
    },
    created () {
        this.isScreenshot = this.conditions.screen
        this.isHistory = this.conditions.history
    },
    methods: {
        toggleTheme () {
            this.isDark = !this.isDark
            this.$vuetify.theme.dark = this.isDark
            this.$emit('toggle-is-dark', this.isDark)
        },
        toggleDiscount () {
            this.isDiscountOnly = !this.isDiscountOnly
            this.$emit('toggle-discount', this.isDiscountOnly)
        },
        toggleGamePass () {
            this.isGamePass = !this.isGamePass
            this.$emit('toggle-gamepass', this.isGamePass)
        },
        toggleEaPlay () {
            this.isEaPlay = !this.isEaPlay
            this.$emit('toggle-eaplay', this.isEaPlay)
        },
        changeStore (locale) {
            if (this.conditions.locale !== locale) {
                this.conditions.locale = locale
                this.$emit('change-store', locale)
            }
        },
        changePriority (sort) {
            if (this.conditions.sortPriority != sort)
                this.$emit('change-priority', sort)
        },
        toggleScreen () {
            this.isScreenshot = !this.isScreenshot
            this.$emit('toggle-screen', this.isScreenshot)
        },
        toggleHistory () {
            this.isHistory = !this.isHistory
            this.$emit('toggle-history', this.isHistory)
        },
        openBottomSearcher () {
            this.$emit('open-bottom-searcher')
        }
    },

}
</script>

<style scoped>

</style>